export default __webpack_public_path__ + "static/media/static_confetti.56ab38bf.svg";